module.exports = __webpack_public_path__ + "static/media/fl2-cover.3d035a86.png";